import { Modelo, Random } from '@ext/index';
import * as Types from './Articulo.types';
import moment, { Moment } from 'moment';
import { get } from 'http';
import { Cliente } from '@/__env/lib/Clientes';
import { Articulo, Precio } from '@/__env/lib/Articulos/Articulo.nav';
import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
import { isString, isNumber, isObject, isArray } from 'util';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { Stock } from '@/__env/lib/Deposito/Stock';
import { Imagen } from '@/__env/lib/Articulos/Imagenes';
import { Contenido } from '@/__env/lib/Articulos/Contenido';
import { Atributo } from '@/__env/lib/Articulos/Atributos';
import { Titulo } from '@/__env/lib/Articulos/Titulos';
import { Marca } from '@/__env/lib/Articulos/Marcas';
import { Sector } from '@/__env/lib/Articulos/Sectores';
import { Linea } from '@/__env/lib/Articulos/Lineas';
import { AtributosGenerales } from '@/__env/lib/Articulos/AtributosGenerales/AtributosGenerales.nav';
import { Unidad } from '@/__env/lib/Articulos/Unidades';

export class IArticulo extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: string = '';
    public Ean13: string = '';
    public Descripcion: string = '';
    public Clasificacion: string = '';
    public CantidadPorEtiquetas: number = 0;
    public CantidadFraccion: number = 1;
    public PesoTotal: number = 0;
    public PesoNeto: number = 0;
    public CantidadUnidad: number = 0;
    public UnidadId: string = '';
    public Reemplazo: string = '';
    public CodigoProveedor: string = '';
    public FechaAlta: Moment = moment( '' );
    public FechaUltimoIngreso: Moment = moment( '' );
    public UltimoCosto: number = 0;
    public FechaUltimaVenta: Moment = moment( '' );
    public CondicionIva: string = '';

    public get AlicuotaIVA()
    {
        if ( this.CondicionIva == 'N' || this.CondicionIva == 'normal' ) return 0.21;
        else if ( this.CondicionIva == 'B' || this.CondicionIva == 'mitad' ) return 0.105;
        else if ( this.CondicionIva == 'S' || this.CondicionIva == 'mitad' ) return 0;
        return 0.21;
    }

    public Piso: string = '';
    public Cola: string = '';
    public Observacion: string = '';

    public LineaId: number = 0;
    public SectorId: number = 0;
    public TituloId: number = 0;
    public MarcaId: number = 0;
    public MarcaAlternativaId: number = 0;

    public Unidad: Unidad = new Unidad();
    public Linea: Linea = new Linea();
    public Sector: Sector = new Sector();
    public Marca: Marca = new Marca();
    public MarcaAlternativa: Marca = new Marca();
    public Titulo: Titulo = new Titulo();



    public Stock: number = 0;
    public Ubicacion: string = '';
    public Ubicaciones: Stock[] = [];
    public Tipo: Types.Tipos = Types.Tipos.Normal;

    public Imagenes: Imagen[] = [];
    public Atributos: Atributo[] = [];
    public AtributosGenerales: AtributosGenerales = new AtributosGenerales();
    public Contenidos: Contenido[] = [];

    public get esFormula(): boolean { return this.Tipo.Id == 'formula'; }

    public get EnStock()
    {
        return this.Stock >= this.CantidadFraccion;
    }

    public get UltimasUnidades()
    {
        return this.EnStock && this.Stock <= this.CantidadFraccion * 10;
    }

    public get UltimaUnidad()
    {
        return this.EnStock && this.Stock == this.CantidadFraccion;
    }

    public Precio: Precio = new Precio();

    public Ofertas: Oferta[] = [];

    protected miniatura: string = '';
    public get Miniatura()
    {
        if ( this.miniatura )
            return this.miniatura;
        else
            this.ImagenPrincipal.Miniatura;
    }
    public Imagen: string = '';


    public get ImagenPrincipal(): Imagen
    {
        if ( this.Imagenes.hasRows() )
        {
            let e = this.Imagenes.find( x => x.Tipo == 'principal' );
            if ( !e )
            {
                return this.Imagenes[0];
            } else
            {
                return e;
            }
        }
        return new Imagen();
    };

    public get esOferta() { return this.Ofertas.hasRows(); }
    public get esLiquidacion() { return this.esOferta && this.Ofertas.findIndex( x => x.Tipo == 'L' ) != -1; }

    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.descripcion = this.Descripcion;
        json.clasificacion = this.Clasificacion;
        json.cantidad_por_etiquetas = this.CantidadPorEtiquetas;
        json.peso_total = this.PesoTotal;
        json.peso_neto = this.PesoNeto;
        json.cantidad_unidad = this.CantidadUnidad;
        json.unidad = this.Unidad;
        json.reemplazo = this.Reemplazo;
        json.codigo_proveedor = this.CodigoProveedor;
        json.fecha_alta = this.FechaAlta.toSQL();
        json.fecha_ultimo_ingreso = this.FechaUltimoIngreso.toSQL();
        json.ultimo_costo = this.UltimoCosto;
        json.fecha_ultima_venta = this.FechaUltimaVenta.toSQL();
        json.condicion_iva = this.CondicionIva;
        json.piso = this.Piso;
        json.cola = this.Cola;
        json.linea_id = this.LineaId;
        json.sector_id = this.SectorId;
        json.titulo_id = this.TituloId;
        json.marca_id = this.MarcaId;
        json.marca_alternativa_id = this.MarcaAlternativaId;
        json.cantidad_fraccion = this.CantidadFraccion;
        json.tipo = this.Tipo.Id;

        return json;
    }


    public set(): boolean
    {
        this.Id = !this.Json.id ? '' : this.Json.id;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion.trim();
        this.Clasificacion = !this.Json.clasificacion ? '' : this.Json.clasificacion;
        this.CantidadPorEtiquetas = !this.Json.cantidad_por_etiquetas ? 0 : this.Json.cantidad_por_etiquetas;
        this.PesoTotal = !this.Json.peso_total ? 0 : this.Json.peso_total;
        this.PesoNeto = !this.Json.peso_neto ? 0 : this.Json.peso_neto;
        this.CantidadUnidad = !this.Json.cantidad_unidad ? 0 : this.Json.cantidad_unidad;
        this.Reemplazo = !this.Json.reemplazo ? '' : this.Json.reemplazo;
        this.CodigoProveedor = !this.Json.codigo_proveedor ? '' : this.Json.codigo_proveedor;
        this.FechaAlta = !this.Json.fecha_alta ? moment( '' ) : moment( this.Json.fecha_alta );
        this.FechaUltimoIngreso = !this.Json.fecha_ultimo_ingreso ? moment( '' ) : moment( this.Json.fecha_ultimo_ingreso );
        this.UltimoCosto = !this.Json.ultimo_costo ? 0 : this.Json.ultimo_costo;
        this.FechaUltimaVenta = !this.Json.fecha_ultima_venta ? moment( '' ) : moment( this.Json.fecha_ultima_venta );
        this.CondicionIva = !this.Json.condicion_iva ? '' : this.Json.condicion_iva;
        this.Piso = !this.Json.piso ? '' : this.Json.piso;
        this.Cola = !this.Json.cola ? '' : this.Json.cola;
        this.LineaId = !this.Json.linea_id ? 0 : this.Json.linea_id;
        this.SectorId = !this.Json.sector_id ? 0 : this.Json.sector_id;
        this.TituloId = !this.Json.titulo_id ? 0 : this.Json.titulo_id;
        this.MarcaId = !this.Json.marca_id ? 0 : this.Json.marca_id;
        this.MarcaAlternativaId = !this.Json.marca_alternativa_id ? 0 : this.Json.marca_alternativa_id;
        this.CantidadFraccion = !this.Json.cantidad_fraccion ? 1 : this.Json.cantidad_fraccion;
        this.Ean13 = !this.Json.ean13 ? '' : this.Json.ean13;
        this.Observacion = !this.Json.observacion ? '' : this.Json.observacion;
        this.miniatura = !this.Json.miniatura ? '' : this.Json.miniatura;
        this.Imagen = !this.Json.imagen ? '' : this.Json.imagen;
        this.Stock = !this.Json.stock ? 0 : this.Json.stock;
        this.Ubicacion = !this.Json.ubicacion ? '' : this.Json.ubicacion;
        this.Tipo = Types.Tipos.toTipo( this.Json.tipo );

        if ( this.Json.precio )
        {
            this.Precio = new Precio( this.Json.precio );
        }

        if ( this.Json.unidad )
        {
            if ( isObject( this.Json.unidad ) )
                this.Unidad = new Unidad( this.Json.unidad );
            else
                this.UnidadId = !this.Json.unidad ? '' : this.Json.unidad;
        }

        if ( this.Json.titulo ) this.Titulo = new Titulo( this.Json.titulo );
        if ( this.Json.sector ) this.Sector = new Sector( this.Json.sector );
        if ( this.Json.linea ) this.Linea = new Linea( this.Json.linea );
        if ( this.Json.marca ) this.Marca = new Marca( this.Json.marca );
        if ( this.Json.marca_alternativa ) this.MarcaAlternativa = new Marca( this.Json.marca_alternativa );
        if ( this.Json.imagenes )
        {
            this.Imagenes = this.Json.imagenes.map( ( x: any ) => new Imagen( x ) );
        }

        if ( this.Json.ofertas )
        {
            let off: any[] = this.Json.ofertas.ofertas;
            this.Ofertas.push( ...off.map( x => new Oferta( x ) ) );
        }


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IArticulo )
    {
        this.Model = Model;
    }

    public Model: IArticulo;
}



export class OpcionDePrecio extends Modelo
{
    public constructor( articulo: Articulo, Json: any = null )
    {
        super( Json );
        this.Articulo = articulo;
        if ( Json )
            this.set();
    }

    public Articulo: Articulo;
    public Tipo: string = '';
    public SubTipo: string = '';
    public Id: string = '';

    public Neto: number = 0;
    public Final: number = 0;

    public Alicuota: number = 0;
    public Descuento: number = 0;
    public PermiteDescuentos: boolean = false;
    public Fijado: boolean = false;

    public set()
    {
        this.Tipo = this.Json.tipo;
        this.SubTipo=this.Json.subtipo;
        this.Id = !this.Json.id ? '' : this.Json.id;
        this.Neto = this.Json.precio;
        this.Alicuota = this.Articulo.AlicuotaIVA;
        this.Descuento = this.Json.descuento;
        this.Final = this.Neto * ( 1 + this.Articulo.AlicuotaIVA);

        this.Existe = true;
    }

}

export class Oferta extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Tipo: string = '';
    public CantidadMinima: number = 0;
    public Porcentaje: number = 0;
    public FechaLimite: Moment;

    public set()
    {
        this.Tipo = this.Json.tipo;
        this.Porcentaje = this.Json.porcentaje;
        this.CantidadMinima = this.Json.cantidad_minima;
        if ( this.Json.fecha_limite )
        {
            this.FechaLimite = !this.Json.fecha_limite ? moment( '' ) : moment( this.Json.fecha_limite );
        }

        this.Existe = true;
    }

    public get esOferta() { return this.Tipo.startsWith( 'oferta' ); }
    public get esOfertaDistribuidor() { return this.Tipo == 'oferta-distribuidor'; }
    public get esOfertaMejora() { return this.Tipo == 'oferta-mejora'; }
    public get esBonificacion() { return this.Tipo.startsWith( 'cliente' ); }
    public get esBonificacionTitulo() { return this.Tipo == 'cliente-titulo'; }
    public get esBonificacionSector() { return this.Tipo == 'cliente-sector'; }
    public get esBonificacionClase() { return this.Tipo == 'cliente-clase'; }
    public get esBonificacionTituloSector() { return this.Tipo == 'cliente-titulo-sector'; }
    public get esBonificacionMarca() { return this.Tipo == 'cliente-marca'; }

    public get Descripcion()
    {
        if ( this.esOfertaMejora )
        {
            return `Oferta mejorada del ${this.Porcentaje.toPorcentaje( 2 )} desde ${this.CantidadMinima} u.` + ( this.FechaLimite ? ` hasta el ${this.FechaLimite.toFechaCorta()}` : '' );
        }
        else if ( this.esOfertaDistribuidor )
        {
            return `Oferta para distribuidores del ${this.Porcentaje.toPorcentaje( 2 )} desde ${this.CantidadMinima} u.` + ( this.FechaLimite ? ` hasta el ${this.FechaLimite.toFechaCorta()}` : '' );
        }
        else if ( this.esOferta )
        {
            return `Oferta del ${this.Porcentaje.toPorcentaje( 2 )} desde ${this.CantidadMinima} u.` + ( this.FechaLimite ? ` hasta el ${this.FechaLimite.toFechaCorta()}` : '' );
        }
        else if ( this.esBonificacionTitulo )
        {
            return `Bonificación en la categoría del ${this.Porcentaje.toPorcentaje( 2 )} desde ${this.CantidadMinima} u.` + ( this.FechaLimite ? ` hasta el ${this.FechaLimite.toFechaCorta()}` : '' );
        }
        else if ( this.esBonificacionSector )
        {
            return `Bonificación en el sector del ${this.Porcentaje.toPorcentaje( 2 )} desde ${this.CantidadMinima} u.` + ( this.FechaLimite ? ` hasta el ${this.FechaLimite.toFechaCorta()}` : '' );
        }
        else if ( this.esBonificacionClase )
        {
            return `Bonificación en toda la línea del ${this.Porcentaje.toPorcentaje( 2 )} desde ${this.CantidadMinima} u.` + ( this.FechaLimite ? ` hasta el ${this.FechaLimite.toFechaCorta()}` : '' );
        }
        else if ( this.esBonificacionMarca )
        {
            return `Bonificación en la marca del ${this.Porcentaje.toPorcentaje( 2 )} desde ${this.CantidadMinima} u.` + ( this.FechaLimite ? ` hasta el ${this.FechaLimite.toFechaCorta()}` : '' );
        }
    }
}


export class IPrecio extends Modelo
{
    constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Articulo: string = '';
    public Cliente: number = 0;
    public Distibuidor: boolean = false;

    public Tipo: string = '';
    public SubTipo: string = '';
    public IdPublicacion: string = '';
    public Modo: 'tipo' | 'cliente' = 'tipo';
    public Cantidad: number = 0;
    public Descuento: number = 0;
    public DescuentoBase: number = 0;
    public Fraccion: number = 0;
    public Alicuota: number = 0;
    public Fijado: boolean = false;
    public RespetaPrecioPactado: boolean = false;
    public PermiteOfertas: boolean = false;
    public PermiteBonificaciones: boolean = false;

    public Lista = {
        DescuentoLista: 0,
        Base: {
            Neto: 0,
            Final: 0
        },
        Cliente: {
            Neto: 0,
            Final: 0
        },
        SinDescuento: {
            Neto: 0,
            Final: 0
        },
        Neto: 0,
        Final: 0,
        Descuento: 0,
    };

    public Importes = {
        Neto: 0,
        Final: 0,
        Iva: 0,
        Descuento: 0,
    };

    public Oferta: Oferta = null;

    public set()
    {
        this.Articulo = !this.Json.articulo ? '' : this.Json.articulo;
        this.Cliente = !this.Json.cliente ? 0 : this.Json.cliente;
        this.Tipo = !this.Json.tipo ? '' : this.Json.tipo;
        this.SubTipo = !this.Json.subtipo ? '' : this.Json.subtipo;
        this.Modo = !this.Json.modo ? '' : this.Json.modo;

        if ( this.Json.lista )
        {
            this.Lista.DescuentoLista = this.Json.lista.descuento_lista;
            this.Lista.Base.Neto = this.Json.lista.base;
            this.Lista.Base.Final = this.Json.lista.base_final;
            this.Lista.Cliente.Neto = this.Json.lista.cliente;
            this.Lista.Cliente.Final = this.Json.lista.cliente_final;
            this.Lista.SinDescuento.Neto = this.Json.lista.sin_descuento;
            this.Lista.SinDescuento.Final = this.Json.lista.sin_descuento_final;

            this.Lista.Neto = this.Json.lista.neto;
            this.Lista.Final = this.Json.lista.final;
            this.Lista.Descuento = this.Json.lista.descuento;
        }



        this.Importes.Neto = this.Json.importes.neto;
        this.Importes.Final = this.Json.importes.final;
        this.Importes.Iva = this.Json.importes.iva;
        this.Importes.Descuento = this.Json.importes.descuento;

        this.Cantidad = this.Json.cantidad;


        this.IdPublicacion = !this.Json.id ? '' : this.Json.id;

        this.Fraccion = !this.Json.fraccion ? 0 : this.Json.fraccion;
        this.Alicuota = !this.Json.alicuota_iva ? 0 : this.Json.alicuota_iva;

        this.Fijado = this.Json.fijado == 'S';
        this.RespetaPrecioPactado = this.Json.respeta_precio_pactado == 'S';
        this.Distibuidor = this.Json.distibuidor == 'S';
        this.PermiteBonificaciones = isArray( this.Json.permite ) && this.Json.permite.includes( 'bonificaciones' );
        this.PermiteOfertas = isArray( this.Json.permite ) && this.Json.permite.includes( 'ofertas' );

        if ( this.Json.oferta )
        {
            this.Oferta = new Oferta( this.Json.oferta );
        }

        //this.Modo = this.Cliente ? 'cliente' : 'tipo';
        this.Existe = true;
    }

    public get hayDescuento() { return this.Oferta && this.Oferta.Existe && this.Lista.Descuento > 0; }
    public get esOferta() { return this.hayDescuento && this.Oferta.esOferta; }
    public get esOfertaDistribuidor() { return this.hayDescuento && this.Oferta.esOfertaDistribuidor; }
    public get esOfertaMejora() { return this.hayDescuento && this.Oferta.esOfertaMejora; }
    public get esBonificacion() { return this.hayDescuento && this.Oferta.esBonificacion; }
    public get esBonificacionTitulo() { return this.hayDescuento && this.Oferta.esBonificacionTitulo; }
    public get esBonificacionSector() { return this.hayDescuento && this.Oferta.esBonificacionSector; }
    public get esBonificacionClase() { return this.hayDescuento && this.Oferta.esBonificacionClase; }
    public get esBonificacionTituloSector() { return this.hayDescuento && this.Oferta.esBonificacionTituloSector; }
    public get esBonificacionMarca() { return this.hayDescuento && this.Oferta.esBonificacionMarca; }

}



export class IEstadisticaVentas extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Articulo: Articulo = new Articulo();
    public Mes: number = 0;
    public Ano: number = 0;
    public Porcentaje: number = 0;
    public Fecha: Moment;
    public Ventas: number = 0;
    public Cantidad: number = 0;

    public set(): boolean
    {
        this.Mes = this.Json.mes;
        this.Ano = this.Json.ano;
        this.Fecha = moment( `${this.Ano}-${this.Mes}-1` );
        this.Ventas = this.Json.ventas;
        this.Cantidad = this.Json.cantidad;
        this.Porcentaje = this.Json.porcentaje;
        if ( isObject( this.Json.articulo ) )
        {
            this.Articulo = new Articulo( this.Json.articulo );
        }

        this.Existe = true;
        return this.Existe;
    }
}